import { logRocketId } from '@/config';

let LogRocket = null;

try {
    if (logRocketId) {
        LogRocket = require('logrocket');

        if (!LogRocket?._isInitialized) {
            LogRocket.init(logRocketId);
        }
    }
} catch (error) {
    console.error(error);
}

export default LogRocket;
